export default __webpack_public_path__ + "static/media/Anita Gupta.828ba499.png";